'use client';

import { ForgotPasswordTemplate } from '@weareconceptstudio/account';

const ForgotPassword = () => {
	return <ForgotPasswordTemplate signInUrl={`/login`} />;
};

export default ForgotPassword;
